import React, { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";
import OtpInput from "react-otp-input";

const OtpVarification = () => {
  const [otpValue, setOtpValue] = useState("");
  const [sendingCode, setSendingCode] = useState(false);

  const { state } = useLocation();

  const updateSendingCode = () => {
    setSendingCode(true);
  };

  useEffect(() => {
    setTimeout(() => {
      updateSendingCode();
    }, 500);
  }, []);

  useEffect(() => {
    if (sendingCode) {
      setSendingCode(false);
      onSubmit();
    }
  }, [sendingCode]);

  let digitValidate = function (ele) {
    setOtpValue(ele);
  };

  return (
    <>
      <section className="login_wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
              <div className="login_form_container">
                <h4
                  style={{
                    fontSize: 24,
                    marginBottom: 0,
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                  className="app_heading"
                >
                  Verify your One-Time Passcode
                </h4>
                <div
                  className="login_form_wrapper"
                  style={{ marginBottom: 0, marginTop: 0 }}
                >
                  <p
                    className="app_text_sm mb-3"
                    style={{ textAlign: "center" }}
                  >
                    Enter the 6 digit verification code we've sent you by SMS
                  </p>
                  <form
                    className="otc mx-auto"
                    name="one-time-code"
                    autoComplete="off"
                    onSubmit={handleSubmit(checkOTP)}
                  >
                    <div className="otp_input_group">
                      <OtpInput
                        value={otpValue}
                        onChange={digitValidate}
                        numInputs={6}
                        className="otp-input"
                      />
                    </div>
                    <button className="app_primary_btn w-100 mt-4">
                      Verify One-Time Passcode
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="login_image_container"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OtpVarification;
